<!-- @let _options = options(); -->

<div class="card">
  <fa-icon
    class="icon"
    [icon]="['fas', notification() ? iconsMap[notification().level].name : 'circle-info']"
    size="lg"
    [style.color]="notification() ? iconsMap[notification().level].color : '#3B82F6'"
  ></fa-icon>

  <div class="texts">
    <h3>{{ title() }}</h3>
    <p>{{ message() }}</p>
    <!-- <span>{{ notification.date | date: 'dd.MM.yyyy, HH:mm:ss' }}</span> -->
  </div>
  <div class="divider"></div>
  <button matRipple class="close-button"><fa-icon [icon]="['fas', 'xmark']"></fa-icon></button>
</div>
